import { Center, Loader, Stack } from '@mantine/core';
import { PageTitle } from 'components/PageTitle';
import { useParams } from 'react-router';
import { useLoadTemplateV2 } from 'shared/hooks/use-load-template-v2';
import { TemplateEditorLayout } from './TemplateEditor';
import { SaveTemplateButton } from './TemplateEditor/SaveTemplateButton';
import { TemplateActionsMenu } from './TemplateEditor/TemplateActionsMenu';
import { TemplateUsedByPills } from './TemplateEditor/TemplateUsedByPills';

export const EditTemplate = () => {
  const { templateId } = useParams<{ templateId: string }>();
  const { template, isTemplateLoading } = useLoadTemplateV2(templateId);

  if (isTemplateLoading || !template) {
    return (
      <Center h="100%">
        <Loader />
      </Center>
    );
  }

  return (
    <Stack gap={0} pb="xl">
      <PageTitle overrideTitle={template.name}>
        <PageTitle.Back />
        {template.name}
        <PageTitle.Subtitle>
          <TemplateUsedByPills planType={template.planType} usedBy={template.usedBy} />
        </PageTitle.Subtitle>
        <PageTitle.Actions>
          <SaveTemplateButton />
          <TemplateActionsMenu template={template} />
        </PageTitle.Actions>
      </PageTitle>
      <TemplateEditorLayout />
    </Stack>
  );
};
